module.exports = __webpack_public_path__ + "static/img/zhineng.98937ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhineng.png
// module id = QPRe
// module chunks = 0